module.exports = __webpack_public_path__ + "fa4cb35fbfe6252ebfbce1bceaf20cee.jpg";